module.exports = __webpack_public_path__ + "1792395595471/fonts/Flaticon.bb9d9c1.eot";